$(document).ready(function() {


    window.setCookie = (name, value, seconds) => {
        let expires = "";
        if (seconds) {
            const date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        const encoded = JSON.stringify(value);
        if(encoded && encoded !== "1"){
            value = encoded;
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    window.getCookie = (name) => {
        name = name ? name.trim() : "";
        const decodedCookie = decodeURIComponent(document.cookie);
        const items = decodedCookie.split(';');
        for(let i = 0; i <items.length; i++) {
            const item = items[i];
            const parts = item.split('=');
            if(parts.length > 1){
                const key = parts[0].trim();
                if(key !== name){
                    continue;
                }
            }
            parts.shift();
            const value = parts.join();
            const decodedValue = JSON.parse(value);
            if(decodedValue){
                return decodedValue;
            }
            return value;
        }
        return "";
    }
});